module.exports = __webpack_public_path__ + "img/email-confirmation-error.4a9b3dbd.svg";